import { render, staticRenderFns } from "./Jitsi.vue?vue&type=template&id=d764ee0e"
import script from "./Jitsi.vue?vue&type=script&lang=js"
export * from "./Jitsi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports